import styled from 'styled-components';
import { ReactComponent as WhatsappSVG } from '../../../assets/icons/whatsapp.svg';
import { ReactComponent as RadioButtonSVG } from '../../../assets/icons/radio-button.svg';
import { ReactComponent as RadioButtonCheckedSVG } from '../../../assets/icons/radio-checked.svg';
import { ReactComponent as ChatBubbleLineSVG } from '../../../assets/icons/chat-bubble-line.svg';

type DescriptionProps = {
  phone: boolean;
};

type OptionChecked = {
  whatsApp?: boolean;
  sms?: boolean;
};

export const DescriptionSection = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Description = styled.span<DescriptionProps>`
  font-size: ${(props) => (props.phone ? 18 : 16)}px;
  font-weight: ${(props) => (props.phone ? 700 : 400)};
  color: #222222;
  line-height: 120%;
  padding-bottom: ${(props) => (props.phone ? 8 : 12)}px;

  @media only screen and (max-width: 960px) {
    text-align: center;
  }
  @media only screen and (max-width: 460px) {
    text-align: left;
  }
`;

export const Links = styled.span`
  font-family: ${(props) => props.theme.primaryFont};
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 16px;
  text-align: center;
  color: #3c50e0;
  padding: 10px 0;
  cursor: pointer;
`;

export const Options = styled.span`
  display: flex;
  text-align: left;
  font-family: ${(props) => props.theme.primaryFont};
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 16px;
  align-items: center;
  color: #222222;
  padding: 12px 0;

  :hover {
    cursor: pointer;
  }

  @media only screen and (max-width: 960px) {
    justify-content: center;
  }

  @media only screen and (max-width: 460px) {
    justify-content: '';
  }
`;

export const OptionText = styled.span`
  font-family: ${(props) => props.theme.primaryFont};
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 16px;
  display: flex;
  align-items: center;
  width: 304px;
  margin: 0 28px 0 16px;
`;

export const WhatsAppIcon = styled(WhatsappSVG)`
  width: 26px;
  height: 26px;
`;

export const RadioButtonWhatsAppOption = styled(RadioButtonSVG)<OptionChecked>`
  width: 24px;
  height: 24px;
  cursor: pointer;
  display: ${(props) => (props.whatsApp ? 'none' : 'block')};
`;

export const RadioButtonSMSOption = styled(RadioButtonSVG)<OptionChecked>`
  width: 24px;
  height: 24px;
  cursor: pointer;
  display: ${(props) => (props.sms ? 'none' : 'block')};
`;

export const WhatsAppChecked = styled(RadioButtonCheckedSVG)<OptionChecked>`
  width: 24px;
  height: 24px;
  cursor: pointer;
  display: ${(props) => (props.whatsApp ? 'block' : 'none')};
`;

export const SMSChecked = styled(RadioButtonCheckedSVG)<OptionChecked>`
  width: 24px;
  height: 24px;
  cursor: pointer;
  display: ${(props) => (props.sms ? 'block' : 'none')};
`;

export const ChatBubbleLineIcon = styled(ChatBubbleLineSVG)`
  width: 26px;
  height: 26px;
`;

export const FooterSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  margin-top: 32px;
`;

export const ButtonSection = styled.div`
  @media only screen and (max-width: 960px) {
    max-width: 400px;
    margin: 0 auto;
  }

  @media only screen and (max-width: 460px) {
    max-width: '';
    margin: '';
  }
`;
